import { Grid, helper, h, html as htmlGrid } from 'gridjs'
import { RowSelection } from 'gridjs/plugins/selection'
import AvatarPersona from './AvatarPersona.js'

const { tipoSistema } = window
const { isFundacao, initTipy } = GLOBAL

let isActivateCheckboxHeader = false

function checkIsValidDate(data) {
	const isDataValid = new Date(data)
	return !isNaN(isDataValid.getTime())
}

export default {
	props: [
		'data',
		'data_inicial_politica',
		'data_final_politica',
		'limparTabela',
		'search',
	],
	emits: [
		'open-modal',
		'open-modal-with-atendimento',
		'ordenate',
		'open-send-email',
		'click-checked-cliente',
		'click-unchecked-cliente',
		'clear-clientes',
	],
	data() {
		return {
			isFundacao: isFundacao(),
			tableAtendimento: null,
			atendimentos: [],
			controllerTabelaFundacao: null,
		}
	},

	components: {
		AvatarPersona,
	},

	watch: {
		limparTabela() {
			this.limparCheckboxAtendimentoRapido()
		},
		// Quando o termo de busca mudar, refaz a consulta
		search() {
			this.atualizarAgendamentoDetalhes()
		},
		// Se o intervalo de datas mudar, refaz a consulta
		data_inicial_politica() {
			this.atualizarAgendamentoDetalhes()
		},
		data_final_politica() {
			this.atualizarAgendamentoDetalhes()
		},
	},

	methods: {
		openModal(id, politica, atendimentoID) {
			this.$emit('open-modal', { id, politica, atendimentoID })
		},

		generateStatusColor(status) {
			if (status === 'Atrasado') return 'color: #c11f39 !important;'
			else if (status === 'Realizado') return 'color: #18b25d !important;'
			else if (status === 'Pendente') return 'color: #ffbb0b !important;'
			else return 'color: #252526 !important;'
		},

		columnsTableAtendimento() {
			const columns = [
				{ id: 'id', name: 'id', hidden: true },
				{
					id: 'checkbox',
					name: htmlGrid(
						html`<label
							data-type="header-fundacao-checkbox"
							class="fundacao-checkbox">
							<input type="checkbox" disabled />
							<span class="checkmark"></span>
						</label>`
					),
					width: '4rem',
					hidden: !this.isFundacao,
					formatter: (cell, row) => {
						const itemAtendimento = this.atendimentos.find(
							(itemAtendimento) => itemAtendimento.id === row._cells[0]?.data
						)
						const id = itemAtendimento.fundacao || itemAtendimento.cliente_pf

						return htmlGrid(
							html`<label
								data-type="body-fundacao-checkbox"
								class="fundacao-checkbox">
								<input type="checkbox" value="${id}" />
								<span class="checkmark"></span>
							</label>`
						)
					},
				},
				{
					id: 'name',
					name: 'Nomes',
					width: '260px',
					formatter: (cell, row) => {
						const id = row._cells[0]?.data
						const atendimento = this.atendimentos?.find(
							(atendimento) => atendimento.id === Number(id)
						)

						const typePolitica = isFundacao()
							? atendimento.politica_fundacao
							: atendimento.politica_cliente

						const columnName = htmlGrid(
							html`<div
								class="inline-flex justify-center items-center gap-8 btn-open-modal-${id}"
								data-tippy-content="${isFundacao()
									? atendimento.nome_fundacao
									: atendimento.nome_cliente_pf}">
								<svg
									class="h-40 w-40 shrink-0"
									style="${GLOBAL.generateAvatarColor(typePolitica)}">
									<use xlink:href="#icon_person"></use>
								</svg>
								${cell}
							</div> `
						)
						setTimeout(() => {
							const openModal = document.querySelector(`.btn-open-modal-${id}`)
							if (openModal) {
								openModal.addEventListener('click', async () => {
									this.handleOpenModal(atendimento)
								})
							}
						}, 0)

						return columnName
					},
				},
				{
					id: 'last_attendant',
					name: 'Último Atendimento',
					width: '150px',
					formatter: (cell, row) => {
						const id = row._cells[0]?.data
						const atendimento = this.atendimentos?.find(
							(atendimento) => atendimento.id === Number(id)
						)
						return this.ultimaData(atendimento)
					},
					sort: {
						compare: (a, b) => {
							if (checkIsValidDate(a) && checkIsValidDate(b)) {
								const dataFormatA = new Date(a)
								const dataFormatB = new Date(b)

								if (dataFormatA > dataFormatB) {
									return 1
								} else if (dataFormatA < dataFormatB) {
									return -1
								}
							}
							return 0
						},
					},
				},
				{
					id: 'date_politic',
					name: 'Data da politica',
					width: '150px',
					formatter: (cell, row) => {
						const id = row._cells[0]?.data
						const atendimento = this.atendimentos?.find(
							(atendimento) => atendimento.id === Number(id)
						)

						if (!atendimento.data) return '-'

						const dateObject = new Date(atendimento.data)

						return GLOBAL.formatDateObject(dateObject)
					},
					sort: {
						compare: (a, b) => {
							if (checkIsValidDate(a) && checkIsValidDate(b)) {
								const dataFormatA = new Date(a)
								const dataFormatB = new Date(b)

								if (dataFormatA > dataFormatB) {
									return 1
								} else if (dataFormatA < dataFormatB) {
									return -1
								}
							}
							return 0
						},
					},
				},
				{
					id: 'status',
					name: 'Status',
					width: '100px',
					formatter: (cell) => {
						return htmlGrid(
							html`<div style="${this.generateStatusColor(cell)}">
								${cell}
							</div> `
						)
					},
				},
				{
					id: 'actions',
					name: '',
					width: '80px',
					formatter: (cell, row) => {
						const id = row._cells[0]?.data
						const atendimento = this.atendimentos?.find(
							(atendimento) => atendimento.id === Number(id)
						)

						const columnActions = htmlGrid(`
              <div class="flex gap-8 items-center justify-center ">
                <div
                  data-tippy-content="Enviar E-mail"
                  class="tippy-el btn-action-${id}">
                  <div
                    class="cursor-pointer hover:scale-125 transition-transform inline-flex active:scale-110 justify-center w-full ">
                    <svg
                      class="h-32 w-32 border border-transparent rounded-lg hover:border-neutral-60 ">
                      <use xlink:href="#icon_email"></use>
                    </svg>
                  </div>
                </div>
                <div data-tippy-content="Enviar E-mail"
                  class="tippy-el btn-criar-${id}" >
                  <div data-tippy-content="Criar atendimento" class="tippy-el">
                    <div class="cursor-pointer hover:scale-125 transition-transform inline-flex active:scale-110 justify-center w-full">
                      <svg class="h-32 w-32 border border-transparent rounded-lg hover:border-neutral-60">
                        <use xlink:href="#icon_check"></use>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            `)

						setTimeout(() => {
							const sendEmail = document.querySelector(`.btn-action-${id}`)
							if (sendEmail) {
								sendEmail.addEventListener('click', async () => {
									this.openSendEmail(
										isFundacao() ? atendimento.fundacao : atendimento.cliente_pf
									)
								})
							}
							const criarAtendimmento = document.querySelector(
								`.btn-criar-${id}`
							)
							if (criarAtendimmento) {
								criarAtendimmento.addEventListener('click', async () => {
									this.handleOpenModal(atendimento, true)
								})
							}
						}, 0)

						return columnActions
					},
				},
			]
			return columns
		},

		async atualizarAgendamentoDetalhes() {
			const exibicao = this.isFundacao
				? '?exibicao=fundacao'
				: '?exibicao=cliente_pf'

			const dataInicialPoliticaFormated = this.data_inicial_politica
				.split('/')
				.reverse()
				.join('-')
			const dataFinalPoliticaFormated = this.data_final_politica
				.split('/')
				.reverse()
				.join('-')

			// Adiciona o termo de busca à URL, se houver
			const searchParam = this.search
				? `&search=${encodeURIComponent(this.search)}`
				: ''

			this.tableAtendimento
				.updateConfig({
					server: {
						url: `/api/atendimentos/${exibicao}&data_inicial=${dataInicialPoliticaFormated}&data_final=${dataFinalPoliticaFormated}${searchParam}`,
						then: (responseAtendimentos) => {
							const atendimentos = responseAtendimentos?.results?.atendimentos
							this.atendimentos = atendimentos
							let arrayForTable = []
							if (atendimentos) {
								if (isFundacao()) {
									arrayForTable = atendimentos.map(
										({
											id,
											sigla_fundacao,
											ultimo_atendimento_fundacao,
											data,
											status,
										}) => [
											id,
											null,
											sigla_fundacao,
											ultimo_atendimento_fundacao,
											data,
											status,
											'teste',
										]
									)
								} else {
									arrayForTable = atendimentos.map(
										({
											id,
											nome_cliente_pf,
											ultimo_atendimento_cliente_pf,
											status,
										}) => [
											id,
											null,
											nome_cliente_pf,
											ultimo_atendimento_cliente_pf,
											status,
											'teste',
										]
									)
								}
							}

							return arrayForTable
						},
						total: (responseAtendimentos) => responseAtendimentos?.count,
					},
					search: false,
					pagination: {
						enabled: true,
						limit: 100,
						server: {
							url: (urlApi, page, limit) => {
								return `${urlApi}&page=${++page}&paginate_by=${limit}`
							},
						},
					},
				})
				.forceRender()
		},

		createTableAtendimento() {
			this.resetController()
			const columns = this.columnsTableAtendimento()
			const exibicao = this.isFundacao
				? '?exibicao=fundacao'
				: '?exibicao=cliente_pf'

			const dataInicialPoliticaFormated = this.data_inicial_politica
				.split('/')
				.reverse()
				.join('-')
			const dataFinalPoliticaFormated = this.data_final_politica
				.split('/')
				.reverse()
				.join('-')

			// Inclui o termo de busca ao montar a URL pela primeira vez
			const searchParam = this.search
				? `&search=${encodeURIComponent(this.search)}`
				: ''

			this.tableAtendimento = new Grid({
				resizable: true,
				columns,
				autoWidth: true,
				width: '100%',
				sort: false,
				server: {
					url: `/api/atendimentos/${exibicao}&data_inicial=${dataInicialPoliticaFormated}&data_final=${dataFinalPoliticaFormated}${searchParam}`,
					then: (responseAtendimentos) => {
						const atendimentos = responseAtendimentos?.results?.atendimentos
						this.atendimentos = atendimentos
						let arrayForTable = []
						if (atendimentos) {
							if (isFundacao()) {
								arrayForTable = atendimentos.map(
									({
										id,
										sigla_fundacao,
										ultimo_atendimento_fundacao,
										data,
										status,
									}) => [
										id,
										null,
										sigla_fundacao,
										ultimo_atendimento_fundacao,
										data,
										status,
										'teste',
									]
								)
							} else {
								arrayForTable = atendimentos.map(
									({
										id,
										nome_cliente_pf,
										ultimo_atendimento_cliente_pf,
										data,
										status,
									}) => [
										id,
										null,
										nome_cliente_pf,
										ultimo_atendimento_cliente_pf,
										data,
										status,
										'teste',
									]
								)
							}
						}
						this.agendaEventoListenerCheckboxAtendimentoRapido()

						arrayForTable = arrayForTable.sort((a, b) => {
							const dateA = new Date(a[3])
							const dateB = new Date(b[3])

							const timeA = isNaN(dateA) ? -Infinity : dateA.getTime()
							const timeB = isNaN(dateB) ? -Infinity : dateB.getTime()
							return timeA - timeB
						})

						return arrayForTable
					},
					total: (responseAtendimentos) => responseAtendimentos?.count,
				},
				search: false,
				pagination: {
					enabled: true,
					limit: 100,
					server: {
						url: (urlApi, page, limit) => {
							return `${urlApi}&page=${++page}&paginate_by=${limit}`
						},
					},
				},
				style: {
					container: {
						border: 'none',
					},
					table: {
						border: 'none',
					},
					tr: {
						border: 'none',
					},
					th: {
						'border-bottom': '1px solid #e9ecef',
					},
					td: {
						'border-bottom': '1px solid #e9ecef',
						cursor: 'pointer',
					},
					footer: {
						border: 'none',
					},
				},
				language: {
					search: {
						placeholder: 'Busque aqui...',
					},
					pagination: {
						previous: '<',
						next: '>',
						to: '/',
						of: 'de',
						showing: 'Mostrando',
						results: () => 'Resultados',
					},
					loading: 'Carregando dados...',
					noRecordsFound: 'Nenhum dado encontrado.',
				},
			})

			this.tableAtendimento.on('beforeLoad', () => {
				this.resetController()
			})

			this.tableAtendimento.render(
				document.querySelector('#table_atendimentos')
			)
		},

		openModalWithAtendimento(id, politica, atendimentoID) {
			this.$emit('open-modal-with-atendimento', {
				id,
				politica,
				atendimentoID,
			})
		},

		ordenate(event, key, dataKey, number) {
			this.$emit('ordenate', { event, key, dataKey, ...number })
		},

		canculateDiference(end) {
			if (end == 'Sem atendimentos') return '-'
			else return GLOBAL.calculateDateDiference(end)
		},

		handleOpenModal(atendimento, withAtendimento) {
			const clienteID = this.isFundacao
				? atendimento.fundacao
				: atendimento.cliente_pf
			const politica = this.isFundacao
				? atendimento.politica_fundacao
				: atendimento.politica_cliente
			if (withAtendimento) {
				this.openModalWithAtendimento(clienteID, politica, atendimento.id)
			} else {
				this.openModal(clienteID, politica, atendimento.id)
			}
		},

		ultimaData(atendimento) {
			return this.isFundacao
				? this.canculateDiference(atendimento.ultimo_atendimento_fundacao)
				: this.canculateDiference(atendimento.ultimo_atendimento_cliente_pf)
		},

		openSendEmail(id) {
			this.$emit('open-send-email', id)
		},

		handleCheckboxTabelaFundacao() {
			const elHeader = document.querySelector(
				'label[data-type="header-fundacao-checkbox"]'
			)
			const listaCheckedOriginal = document.querySelectorAll(
				'label[data-type="body-fundacao-checkbox"]'
			)

			listaCheckedOriginal.forEach((itemCheckedOriginal) => {
				itemCheckedOriginal.addEventListener(
					'click',
					(e) => {
						const currentTarget = itemCheckedOriginal.querySelector(
							'input[type="checkbox"]'
						)

						setTimeout(() => {
							const inputHeader = elHeader.querySelector(
								'input[type="checkbox"]'
							)
							const listaChecked = document.querySelectorAll(
								'label[data-type="body-fundacao-checkbox"] input[type="checkbox"]:checked'
							)

							if (currentTarget.checked) {
								this.$emit('click-checked-cliente', currentTarget.value)
							} else {
								this.$emit('click-unchecked-cliente', currentTarget.value)
							}

							if (!isActivateCheckboxHeader && listaChecked.length >= 1) {
								inputHeader.indeterminate = true
								isActivateCheckboxHeader = true
							} else if (isActivateCheckboxHeader && listaChecked.length <= 0) {
								inputHeader.indeterminate = false
								isActivateCheckboxHeader = false
							}
						}, 0)
					},
					{ signal: this.controllerTabelaFundacao.signal }
				)
			})

			elHeader?.addEventListener(
				'click',
				(e) => {
					setTimeout(() => {
						this.limparCheckboxAtendimentoRapido()
						this.$emit('clear-clientes')
					}, 0)
				},
				{ signal: this.controllerTabelaFundacao.signal }
			)
		},

		agendaEventoListenerCheckboxAtendimentoRapido() {
			let currentAttemp = 1
			const maxAttemp = 5

			let intervalId = setInterval(() => {
				const isRenderTableCheckedItems = document.querySelectorAll(
					'label[data-type="body-fundacao-checkbox"] span.checkmark'
				).length

				if (isRenderTableCheckedItems >= 0) {
					this.handleCheckboxTabelaFundacao()
					clearInterval(intervalId)
				} else if (currentAttemp > maxAttemp) {
					clearInterval(intervalId)
				} else {
					currentAttemp++
				}
			}, 1000)
		},

		resetController() {
			if (this.controllerTabelaFundacao) {
				this.controllerTabelaFundacao.abort()
			}
			this.controllerTabelaFundacao = new AbortController()
		},

		limparCheckboxAtendimentoRapido() {
			const checkboxOriginal = document.querySelector(
				'label[data-type="header-fundacao-checkbox"] input[type="checkbox"]'
			)
			const listaCheckedOriginal = document.querySelectorAll(
				'label[data-type="body-fundacao-checkbox"] input[type="checkbox"]:checked'
			)

			if (listaCheckedOriginal.length > 0) {
				Array.from(listaCheckedOriginal).forEach((itemCheckBox) => {
					itemCheckBox.checked = false
				})
			}

			checkboxOriginal.indeterminate = false
			checkboxOriginal.checked = false
			isActivateCheckboxHeader = false
		},
	},

	computed: {
		skeletonClass() {
			return { skeleton: this.data[0]?.placeholder }
		},
	},
	mounted() {
		this.createTableAtendimento()
		setTimeout(() => {
			tippy('[data-tippy-content]', {
				allowHTML: true,
				placement: 'top',
				boundary: 'HTMLElement',
			})
		}, 1000)

		this.tableAtendimento.on('ready', () => {
			this.agendaEventoListenerCheckboxAtendimentoRapido()
		})
	},

	beforeUnmount() {
		this.controllerTabelaFundacao.abort()
	},

	template: html`
		<div
			id="wrapper-container-tabela"
			class="w-[100%] max-h-[29.15rem] overflow-y-auto overflow-x-scroll flex-1 table-wrapper  box-border relative">
			<table id="table_atendimentos" class="!flex" js-table-ordenation></table>
		</div>
	`,
}
